import React, { memo } from 'react';
import classNames from 'classnames';

const DeviceTableCell = ({ displayString, center }) => {
  return (
    <div
      id="DeviceTable_cellWrapper"
      className={classNames({
        DeviceTable_cellWrapper: true,
        ...(center && { DeviceTable_cellWrapper_Center: true })
      })}
      data-tip={displayString}
    >
      {displayString}
    </div>
  );
};

export default memo(DeviceTableCell);
